module.exports = __webpack_public_path__ + "static/China-Wall-compressed-849271829f3480d3df0ec7b3a39c9fad.mp4";